module.exports = __webpack_public_path__ + "static/pubal-7db02c7c377b63b938dbf8d1d2dc27e8.svg";